<template>

    <div class="dropdown dropdown-multichoice" ref="dropdown" :class="{'disabled': this.disabled}" :id="'dropdown-multichoice-'+this.name">
        <button class="btn btn-outline-light dropdown-toggle" aria-expanded="true" data-toggle="dropdown" type="button" ref="dropdownToggle"
            :class="{'active': this.mutChecked.length > 0 && !this.hideCountBadge, 'icon-button': this.type === 'icon-button'}" @click="dropdownTogglerClick">
                <i class="dropdown-icon" v-if="this.icon" :class="this.icon"></i>
                <span v-if="this.label">{{ this.label }}</span>
                <small class="bdg-count btn-primary" v-if="this.mutChecked.length > 0 && !this.hideCountBadge">{{ this.mutChecked.length }}</small>
        </button>
        <div class="dropdown-menu" :class="{'dropdown-menu-right': this.alignRight}" ref="dropdownMenu">
            <div class="bg-light dropdown-item px-3 pt-3 pb-2 noselect">
                <h5>{{ this.title }}</h5>

                <div v-if="this.options.length > 0">
                    <div v-if="allowSearch" class="mt-2 mb-1">
                        <input type="search" autocomplete="off" class="form-control" ref="searchInput" :placeholder="trans('search-placeholder')" v-model="searchString">
                    </div>
                    <a class="text-dark check-uncheck-link" @click="checkUncheckAll()">{{ trans('check-uncheck-all') }}</a>
                </div>
            </div>

            <div class="dropdown-menu-content" :class="{'has-submit': hasSubmit() || hasReset()}" v-if="this.options.length > 0">
                <div v-if="this.grouppedOptions" class="groupped-options">
                    <div class="dropdown-item p-0" v-for="(group, index) in filteredGroups()" :key="index">
                        <div class="form-group form-check">
                            <input type="checkbox" class="form-check-input"
                                :name="getInputName({name: group, id: index})"
                                :id="name+'_chb_group_'+index"
                                :ref="'chb_group_'+index"
                                @change="checkUncheckGroup(group, $event.target.checked)">
                            <label class="form-check-label font-weight-bold" :for="name+'_chb_group_'+index">{{ group }}</label>
                        </div>

                        <div class="dropdown-submenu">
                          <div class="dropdown-item" v-for="(item) in filteredOptions(group)" :key="item.value">
                            <div class="form-group form-check">
                                <input type="checkbox" class="form-check-input"
                                    :name="getInputName(item)"
                                    :value="item.value"
                                    :id="getInputId(item)"
                                    :checked="itemChecked(item)"
                                    @change="itemChange(item)">

                                <label class="form-check-label" :for="getInputId(item)">{{ item.label }}</label>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="dropdown-item p-0" v-for="(item) in filteredOptions()" :key="item.value">
                        <div class="form-group form-check">
                            <input type="checkbox" class="form-check-input"
                                :name="getInputName(item)"
                                :value="item.value"
                                :id="getInputId(item)"
                                :checked="itemChecked(item)"
                                @change="itemChange(item)">

                            <label class="form-check-label" :for="getInputId(item)">{{ item.label }}</label>
                        </div>
                    </div>
                </div>

                <div class="dropdown-btns">
                    <button class="btn btn-danger" v-if="hasReset()" @click="reset()" :disabled="disabled">
                        <i class="far fa-undo fa-fw mr-2"></i>
                        {{ trans('reset') }}
                    </button>
                    <button class="btn btn-primary" v-if="hasSubmit()" @click="submit()" :disabled="disabled || this.mutChecked.length === 0">
                        <i class="far fa-check fa-fw mr-2"></i>
                        {{ trans('save') }}
                    </button>
                </div>
            </div>
            <div class="dropdown-menu-content text-center py-3 font-weight-normal text-muted" v-else>
                {{ trans('no-options') }}
            </div>
        </div>
    </div>

</template>

<script>
    import {cloneDeep} from "lodash";
    import TranslationsUtils from "../../app-components/TranslationsUtils";

    export default {
        mixins: [TranslationsUtils],
        props: {
            'type': { // form-control | icon-button
                type: String,
                default: 'form-control'
            },
            'name': {
                type: String
            },
            'icon': {
                type: String
            },
            'label': {
                type: String
            },
            'title': {
                type: String
            },
            'options': {
                type: Array
            },
            'checked': {
                type: Array,
                default: function() {
                    return [];
                }
            },
            'disabled': {
                type: Boolean,
                default: false
            },
            'hideCountBadge': {
                type: Boolean,
                default: false
            },
            'alignRight': {
                type: Boolean,
                default: false
            },
            'allowSearch': {
                type: Boolean,
                default: false
            },
            'grouppedOptions': {
                type: Boolean,
                default: false
            },
            'onchange': { type: Function },
            'onsubmit': { type: Function },
            'onreset': { type: Function },
            'resetTrigger': { type: Number }
        },

        data() {
            return {
                'mutChecked': cloneDeep(this.checked),
                'searchString': '',
                'groups': [],
            };
        },

        mounted() {
            // extract unique groups once at start
            if(this.grouppedOptions) {
                this.groups = this.options.reduce((acc, item) => {
                    if(item.group && !acc.includes(item.group)) {
                        acc.push(item.group);
                    }
                    return acc;
                }, []).sort ((a, b) => {
                    a = a.toLowerCase();
                    b = b.toLowerCase();

                    if(a.toLowerCase() < b) return -1;
                    if(a > b) return 1;
                    return 0;
                });
            }
        },

        methods: {
            allOptionsByGroup(group) {
                const opts = Array.isArray(this.options) ? this.options : [];
                return opts.filter(o => o.group === group);
            },

            dropdownTogglerClick(event) {
                this.$nextTick(() => {
                    const el = this.$refs.dropdown;

                    if(!el.classList.contains('open')) {
                        return;
                    }

                    this.updateDropDirection();

                    if(this.allowSearch) {
                        this.$refs.searchInput.select();
                    }
                });
            },

            // na spodku stranky sa menu nezmesti pod tlacidlo a nedalo by sa doscrollovat na koniec zoznamu.
            // trieda sa nastavuje priamo cez classList - cez :class by vue pri prekresleni zmazalo
            // triedu .open/.show, ktoru na element pridava bootstrap, a dropdown by sa hned zavrel
            updateDropDirection() {
                const el = this.$refs.dropdown;
                const toggle = this.$refs.dropdownToggle;
                const menu = this.$refs.dropdownMenu;

                if(!el || !toggle || !menu) {
                    return;
                }

                const toggleRect = toggle.getBoundingClientRect();
                const spaceBelow = window.innerHeight - toggleRect.bottom;
                const dropUp = menu.offsetHeight > spaceBelow && toggleRect.top > spaceBelow;

                el.classList.toggle('dropup', dropUp);
            },

            getInputId(item) {
                return this.name + '-' + item.value;
            },
            getInputName(item) {
                return this.name + '[' + item.value + ']';
            },

            itemChecked(item) {
                return this.mutChecked.includes(item.value);
            },

            itemChange(item) {
                const i = this.mutChecked.indexOf(item.value);

                if (i !== -1) {
                    this.mutChecked.splice(i, 1);
                } else {
                    this.mutChecked.push(item.value);
                }

                this.triggerChange();

                if (this.grouppedOptions) {
                    this.checkGroupsCheckedState();
                }
            },


            hasSubmit() {
                return typeof this.onsubmit !== 'undefined';
            },

            submit() {
                if(this.hasSubmit()) {
                    this.onsubmit(this.mutChecked);
                }
                this.closeDropdown();
            },

            hasReset() {
                return typeof this.onreset !== 'undefined';
            },

            reset() {
                if(this.hasReset()) {
                    this.onsubmit([]); // toto je takto naschval!
                }
                this.closeDropdown();
            },

            updateCheckedItems(checkedItems) {
                this.mutChecked = cloneDeep(checkedItems);
                this.checkGroupsCheckedState();
            },

            closeDropdown() {
                this.$el.classList.remove('open');
            },

            checkUncheckAll() {
                const visible = this.filteredOptions();          // len aktuálne viditeľné
                const visibleValues = visible.map(o => o.value);
                const checked = new Set(this.mutChecked);

                const allVisibleChecked = visibleValues.every(v => checked.has(v));

                if (allVisibleChecked) {
                    // uncheckni len tie, ktoré sú viditeľné
                    visibleValues.forEach(v => checked.delete(v));
                } else {
                    // checkni všetky viditeľné
                    visibleValues.forEach(v => checked.add(v));
                }

                this.mutChecked = Array.from(checked);
                this.triggerChange();
                this.checkGroupsCheckedState();
            },

            checkUncheckGroup(group, isChecked) {
                const list = this.searchString
                           ? this.filteredOptions(group)         // pri hľadaní toggluj len viditeľné
                           : this.allOptionsByGroup(group);      // bez hľadania toggluj celú skupinu

                const set = new Set(this.mutChecked);

                if (isChecked) {
                    for (const o of list) set.add(o.value);
                } else {
                    for (const o of list) set.delete(o.value);
                }

                this.mutChecked = Array.from(set);
                this.triggerChange();
                this.checkGroupsCheckedState();
            },


            triggerChange() {
                if (this.onchange) {
                    this.onchange(this.name, this.mutChecked);
                }
            },

            normalizeText(text) {
                return String(text).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
            },

            filteredOptions(group) {
                var _this = this;
                var opts = Array.isArray(this.options) ? this.options : [];
                var q = this.normalizeText(this.searchString || '');
                var g = null;

                if(group) {
                    opts = opts.filter(function (item) {
                        return item.group === group;
                    });
                    g = this.normalizeText(group);
                }

                if (!q) return opts;

                return opts.filter(function (item) {
                  var label = item && item.label != null ? _this.normalizeText(item.label) : '';
                  var value = item && item.value != null ? _this.normalizeText(item.value) : '';
                  return label.indexOf(q) !== -1 || value.indexOf(q) !== -1 || (g && g.indexOf(q) !== -1);
                });
            },

            filteredGroups() {
              const opts = Array.isArray(this.groups) ? this.groups : [];
              const q = this.normalizeText(this.searchString || '');

              const out = {};

              for (let i = 0; i < opts.length; i++) {
                const group = opts[i];

                if (!q) {
                    out[i] = group; // keep array index from unfiltered array of all groups
                    continue;
                }

                const name = group ? this.normalizeText(group) : '';
                if (name.indexOf(q) !== -1 || this.filteredOptions(group).length > 0) {
                out[i] = group;
                }
              }

              return out;
            },

            checkGroupsCheckedState() {
                const groups = this.filteredGroups(); // objekt: index => group
                const checkedSet = new Set(this.mutChecked);

                for (const index in groups) {
                    const group = groups[index];

                    // ber všetky položky v skupine (nie len filtrované vyhľadávaním!)
                    const options = this.allOptionsByGroup(group);
                    const total = options.length;

                    const selected = options.reduce(
                      (acc, o) => acc + (checkedSet.has(o.value) ? 1 : 0),
                      0
                    );

                    const ref = this.$refs['chb_group_' + index];
                    const el = Array.isArray(ref) ? ref[0] : ref;
                    if (!el) continue; // nikdy neukončuj celú metódu

                    el.indeterminate = selected > 0 && selected < total;
                    el.checked = total > 0 && selected === total;
                }
            },
        },

        watch: {
            options: {
                immediate: true,
                handler(newVal) {
                  if (!this.grouppedOptions) return;
                  const uniq = (Array.isArray(newVal) ? newVal : [])
                    .map(o => o.group)
                    .filter(g => !!g);

                  // unikátne a zotriedené case-insensitive
                  this.groups = Array.from(new Set(uniq)).sort((a, b) => {
                    a = String(a).toLowerCase(); b = String(b).toLowerCase();
                    if (a < b) return -1;
                    if (a > b) return 1;
                    return 0;
                  });

                  this.$nextTick(() => this.checkGroupsCheckedState());
                }
            },

            resetTrigger() {
                this.mutChecked = cloneDeep(this.checked);
                this.$nextTick(() => this.checkGroupsCheckedState());
            },

            searchString() {
                this.$nextTick(() => this.checkGroupsCheckedState());
            }
        }
    }
</script>


<style lang="scss">
    .dropdown-multichoice {
        width: 100%;

        &.disabled {
            opacity: 0.7;
            pointer-events: none;
        }

        .dropdown-toggle {
            color: #3e515b;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
            border: 1px solid #b9c8de;
            border-radius: 0;
            background: white;

            &.active {
                padding-right: 40px;
                color: #343A40;
            }

            .bdg-count {
                position: absolute;
                right: 5px;
                top: 5px;
                padding: 5px 8px;
                border-radius: 3px;
                color: #fff; // .card small by ho inak zosedivelo
            }

            &.icon-button {
                border: 0;
                background: none;
                width: auto;
            }
        }

        &.dropup .dropdown-menu {
            top: auto;
            bottom: 100%;
        }

        .dropdown-menu {
            h5 {
                font-weight: bold;
                padding: 0px;
                font-size: 0.9rem;
                user-select: none;
            }
            .check-uncheck-link {
                padding: 0px;
                margin: 0px;
                font-size: 0.7rem;
                cursor: pointer;
                user-select: none;
                text-decoration: underline;
            }

            .dropdown-menu-content {
                max-height: 40vh;
                overflow-y: auto;

                &.has-submit {
                    padding-bottom: 36px;
                }

                .groupped-options {
                    & > .dropdown-item {
                        &:hover { background-color: white; }

                        .dropdown-submenu {
                            .dropdown-item {
                                border: none;
                                padding: 0 2rem 0 2rem;
                            }
                        }
                    }
                }
            }

            .form-check {
                margin: 0px;

                .form-check-label {
                     display: block;
                     margin: 0px;
                     padding: 10px 10px 10px 50px;
                     user-select: none;

                     &:before {
                        top: 10px;
                        left: 15px;
                     }
                     &:after {
                        top: 15px;
                        left: 20px;
                     }
                }
            }

            .dropdown-btns {
                display: flex;
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                background-color: white;

                .btn {
                    border-radius: 0;
                    display: block;
                    cursor: pointer;
                    color: white;
                    min-width: 50%;
                    flex-grow: 1;

                    .far { color: white !important; }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/components/basic/DropdownMultichoice.vue